import monthCashBalance from './monthCashBalance';
import interestRate from './interestRate';
import interestBank from './interestBank';
import interestDailyReport from './interestDailyReport';
import interOrderPool from './interOrderPool';
import interPool from './interPool';
import businessType from './businessType';
import interOrderType from './interOrderType';
import advanced from './advanced';

export default {
  ...monthCashBalance,
  ...interestRate,
  ...interestBank,
  ...interestDailyReport,
  ...interOrderPool,
  ...interPool,
  ...businessType,
  ...interOrderType,
  ...advanced,
};
